const FontSize = {
	t1: {
		size: 65,
		lineHeight: 1.5,
		weight: 800,
		mobileSize: 55
	},

	t2: {
		size: 53,
		lineHeight: 1.5,
		weight: 600,
		mobileSize: 43
	},

	t3: {
		size: 37,
		lineHeight: 1.5,
		weight: 600,
		mobileSize: 30
	},

	t4: {
		size: 26,
		lineHeight: 1.5,
		weight: 600,
		mobileSize: 24
	},

	t5: {
		size: 22,
		lineHeight: 1.5,
		weight: 400,
		mobileSize: 20
	},

	t6: {
		size: 16,
		lineHeight: 1.5,
		weight: 400,
		mobileSize: 15
	},

	t7: {
		size: 12,
		lineHeight: 1.5,
		weight: 400,
		mobileSize: 11
	},

	title: {
		size: 63,
		lineHeight: 1.5,
		weight: 600,
		mobileSize: 50
	}
}

export default FontSize
